module.exports = __webpack_public_path__ + "img/slide02_m.462395c4.jpg";